import { assert } from '@sama/js-core';
import { matches } from '@sama/micro-dash';
import { isUndefined } from 'lodash';
import { SingleChoiceAttribute } from '../../../team-apis/otterdam/taxonomy';
import { AttributeHelper } from './attribute-helper';

export class SingleChoiceAttributeHelper extends AttributeHelper<SingleChoiceAttribute> {
  getLabel(answer: string, attribute: SingleChoiceAttribute) {
    return this.getMatchingOption(answer, attribute)?.label || '';
  }

  getDefaultOptionValue(attribute: SingleChoiceAttribute) {
    const attributeOption = attribute.options.find(
      (option) => option.isDefault,
    );
    assert(
      attributeOption,
      `attribute option ${attribute.name} has no default value`,
    );
    return attributeOption.value;
  }

  isInvalidValue(value: string, attribute: SingleChoiceAttribute) {
    return isUndefined(this.getMatchingOption(value, attribute));
  }

  private getMatchingOption(answer: string, attribute: SingleChoiceAttribute) {
    return attribute.options.find(matches({ value: answer }));
  }
}
